
namespace GeniuzPOS.RefundReasonReport {

    @Serenity.Decorators.registerClass()
    export class ReportRefundReasonByBillDialog extends Serenity.EntityDialog<ReportRefundReasonByBillRow, any> {
        protected getFormKey() { return ReportRefundReasonByBillForm.formKey; }
        protected getIdProperty() { return ReportRefundReasonByBillRow.idProperty; }
        protected getLocalTextPrefix() { return ReportRefundReasonByBillRow.localTextPrefix; }
        protected getNameProperty() { return ReportRefundReasonByBillRow.nameProperty; }
        protected getService() { return ReportRefundReasonByBillService.baseUrl; }
        protected getDeletePermission() { return ReportRefundReasonByBillRow.deletePermission; }
        protected getInsertPermission() { return ReportRefundReasonByBillRow.insertPermission; }
        protected getUpdatePermission() { return ReportRefundReasonByBillRow.updatePermission; }

        protected form = new ReportRefundReasonByBillForm(this.idPrefix);

    }
}